// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__38svR","location":"Header_location__2FNxl"};